export const environment = {
  production: false,
  apiUrl: 'https://api.planwise-dev.roche.com',
};
